import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "compose__style_list_numbers",
  "use": "compose__style_list_numbers-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"compose__style_list_numbers\">\n  <title>Add numbered list</title>\n  <path fill=\"none\" stroke-width=\"1.3\" stroke-linecap=\"round\" d=\"M4.702 13.618h11.286M4.702 8.765h11.286M4.223 3.912h11.765\" />\n  <text font-size=\"4\" font-weight=\"500\" stroke=\"none\">\n    <tspan x=\".5\" y=\"5\">1</tspan>\n    <tspan x=\".5\" y=\"10\">2</tspan>\n    <tspan x=\".5\" y=\"15\">3</tspan>\n  </text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol